export default function EmailTemplateSkeleton() {

  return (
    <div className="space-y-3">
      {[1,2,3,4].map(i => (
        <div
          key={i}
          className="h-12 bg-gray-200 animate-pulse rounded"
        />
      ))}
    </div>
  );
}